import { addAuth } from "@/store/features/auth.slice";
import { AppDispatch, RootState } from "@/store/index";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LogoDark from "../../../assets/images/logo/logo.png";
import Logo from "../../../assets/images/logo/logo.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLoginMutation } from "@/services/auth.service";
import { emailRegex } from "@/utils/regex";

const Login = () => {
  const { t } = useTranslation();
  const { register, handleSubmit, formState: {errors} } = useForm<{
    email: string;
    password: string;
  }>();
  const [login, { data = {}, isLoading, isError, error }] = useLoginMutation();
  const navigate = useNavigate();
  const { auth } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (auth.name) navigate("/dashboard");
  }, []);

  const onSubmit = handleSubmit(async (values) => login(values));

  useEffect(() => {
    if(data?.data) {
      dispatch(addAuth(data?.data));
      navigate("/dashboard");
    }
  }, [data?.data])

  return (
    <div className="w-full flex justify-center items-center">
      <div className="hidden w-full md:block sm:w-3/4 md:w-1/2 lg:w-1/3">
        <div className="py-17.5 px-26 text-center">
          <span className="inline-block">
            <img className="" src={Logo} alt="Logo" />
          </span>
        </div>
      </div>

      <div className="border-stroke dark:border-slate-700 w-full sm:w-3/4 md:w-1/2 lg:w-1/3 md:border-l-2">
        <div className="w-full p-4 sm:p-12.5 xl:p-17.5">
          <h2 className="mb-9 text-2xl font-bold text-black dark:text-white sm:text-title-xl2">
            {t("login.title")}
          </h2>
          <form onSubmit={onSubmit}>
            {
              isError &&  <p className="mb-2 text-rose-600">{t("error.email_or_password")}</p>
            }
            <div className="mb-4">
              <label className="mb-2.5 block font-medium text-black dark:text-white">
                {t("form.email")}
              </label>
              <div className="relative">
                <input
                  type="email"
                  placeholder={t("placeholder.email")}
                  className="w-full rounded-lg border border-stroke bg-transparent  py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-slate-600 dark:bg-form-input dark:focus:border-primary invalid:border-red-500"
                  {...register("email", {
                    required: t("validation.required"),
                    pattern: {
                      value: emailRegex,
                      message: t("validation.email_valid")
                    }
                  })}
                />
                <span className="absolute right-4 top-4">
                  <i className="fa-light fa-user fa-lg" />
                </span>
              </div>
              { errors.email && <p className="mt-1 text-rose-600">{errors.email.message}</p>}
            </div>

            <div className="mb-6">
              <label className="mb-2.5 block font-medium text-black dark:text-white">
                {t("form.password")}
              </label>
              <div className="relative">
                <input
                  type="password"
                  placeholder={t("placeholder.password")}
                  className="w-full rounded-lg border border-stroke bg-transparent py-4 pl-6 pr-10 outline-none focus:border-primary focus-visible:shadow-none dark:border-slate-600 dark:bg-form-input dark:focus:border-primary"
                  {...register("password", {
                    required: t("validation.required")
                  })}
                />

                <span className="absolute right-4 top-4">
                  <i className="fa-light fa-lock-keyhole fa-lg" />
                </span>
              </div>
              { errors.password && <p className="mt-1 text-rose-600">{errors.password.message}</p>}
            </div>

            {/* <div className="mt-2 mb-3">
              <p>
                <Link to="/reset" className="text-primary">
                  Forgot password?
                </Link>
              </p>
            </div> */}

            <div className="mb-5">
              <input
                type="submit"
                value={t("login.btn")}
                className="w-full cursor-pointer rounded-lg border border-primary bg-primary p-4 text-white transition hover:bg-opacity-90"
                disabled={isLoading}
              />
            </div>

            {/* <div className="mt-6 text-center">
              <p>
                Don't have any account?{" "}
                <Link to="/register" className="text-primary">
                  Sign Up
                </Link>
              </p>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
